import { Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Home from "../pages/homepage/Home";
import TermsofServices from "../pages/cmsPage/TermsofServices";
import ContactUs from "../pages/cmsPage/ContactUs";
import AboutUs from "../pages/cmsPage/AboutUs";

import Layout from "../components/Layout";

import Dashboard from "../pages/user/Dashboard";
import Addresses from "../pages/user/Addresses";
import Orders from "../pages/user/Orders";
import Account from "../pages/user/Account";
import OrderDetails from "../pages/user/OrderDetails";

import PrivateRoutes from "./PrivateRoute";
import DashboardLayout from "../pages/user/DashboardLayout";
import ChangePassword from "../pages/user/ChangePassword";

import OrderConfirmed from "../pages/order/Confirmed";
import Cart from "../pages/order/Cart";
import Checkout from "../pages/order/Checkout";

import BlogList from "../pages/blogs/ListPage";
import BlogDetail from "../pages/blogs/DetailPage";

import BrandList from "../pages/brands/ListPage";
import BrandDetail from "../pages/brands/DetailPage";

import ProductList from "../pages/products/ListPage";
import ProductDetail from "../pages/products/DetailPage";

import CategoryList from "../pages/categories/ListPage";
import CategoryDetail from "../pages/categories/DetailPage";

import NotFound from "../pages/errors/NotFound";
import LoginCanvas from "../pages/canvas/LoginCanvas";
import RegisterCanvas from "../pages/canvas/RegisterCanvas";
import Wishlist from "../pages/order/Wishlist";
import Career from "../pages/cmsPage/Career";
import Expansion from "../pages/cmsPage/Expansion";
import Services from "../pages/cmsPage/Services";

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />

          {/* details pages */}
          <Route path="terms-and-conditions" element={<TermsofServices />} />
          <Route path="privacy-policy" element={<TermsofServices />} />
          <Route
            path="return-and-refund-policy"
            element={<TermsofServices />}
          />
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="about-us" element={<AboutUs />} />
          <Route path="career" element={<Career />} />
          <Route path="expansion-zones" element={<Expansion />} />
          <Route path="services" element={<Services />} />


          {/* main list pages */}
          <Route path="blog" element={<BlogList />} />
          <Route path="blog/:slug" element={<BlogDetail />} />

          <Route path="shop" element={<ProductList />} />
          <Route path="shop/:slug" element={<ProductDetail />} />

          <Route path="categories" element={<CategoryList />} />
          <Route path="categories/*" element={<CategoryDetail />} />

          <Route path="brands" element={<BrandList />} />
          <Route path="brands/:slug" element={<BrandDetail />} />

          {/* wishlist page */}
          <Route path="wishlist" element={<Wishlist/>} />

          {/* cart pages */}
          <Route path="cart" element={<Cart />} />
          <Route path="checkout" element={<Checkout />} />

          <Route path="order-confirmation" element={<OrderConfirmed />} />
          <Route path="users/login" element={<LoginCanvas/>} />
          <Route path="users/register" element={<RegisterCanvas/>} />

          {/* users routes */}
          <Route path="users" element={<PrivateRoutes />}>
            <Route element={<DashboardLayout />}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="orders" element={<Orders />} />
              <Route path="order-details/:id" element={<OrderDetails />} />
              <Route path="addresses" element={<Addresses />} />
              <Route path="account" element={<Account />} />
              <Route path="change-password" element={<ChangePassword />} />
            </Route>
          </Route>

          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </AnimatePresence>
  );
};

export default AnimatedRoutes;
